"use client";

import ArticleIcon from "@mui/icons-material/Article";
import HomeIcon from "@mui/icons-material/Home";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

/**
 * Reusable Breadcrumbs Component
 * 
 * Usage:
 * - Blog listing: <Breadcrumbs />
 * - Article page: <Breadcrumbs categoryName="Philosophy" categorySlug="our-philosophy" />
 */
const Breadcrumbs = ({ categoryName, categorySlug }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      {/* Home */}
      <Link href="/" style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
        <HomeIcon sx={{ fontSize: 20, color: "text.primary", mr: 0.5 }} />
        <Typography variant="body1" sx={{ color: "text.primary", "&:hover": { opacity: 0.8 } }}>
          Home
        </Typography>
      </Link>

      <ChevronRightIcon sx={{ color: "text.secondary", mx: ".25rem" }} />

      {/* Blog */}
      {categoryName ? (
        // On article page - Blog is clickable
        <Link href="/blog" style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
          <ArticleIcon sx={{ fontSize: 20, color: "text.primary", mr: 0.5 }} />
          <Typography variant="body1" sx={{ color: "text.primary", "&:hover": { opacity: 0.8 } }}>
            Blog
          </Typography>
        </Link>
      ) : (
        // On blog listing page - Blog is current (not clickable, but no special styling)
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ArticleIcon sx={{ fontSize: 20, color: "text.primary", mr: 0.5 }} />
          <Typography variant="body1" sx={{ color: "text.primary" }}>
            Blog
          </Typography>
        </Box>
      )}

      {/* Category (only on article pages) */}
      {categoryName && (
        <>
          <ChevronRightIcon sx={{ color: "text.secondary", mx: ".25rem" }} />
          <Link 
            href={`/blog?category=${categorySlug}`} 
            style={{ textDecoration: "none" }}
          >
            <Typography variant="body1" sx={{ color: "text.primary", "&:hover": { opacity: 0.8 } }}>
              {categoryName}
            </Typography>
          </Link>
        </>
      )}
    </Box>
  );
};

export default Breadcrumbs;
